import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerPaymentDetails.css';
import { DateTimeHelper,RoleConfiguration } from 'utils-lib';
import { Icon,TextField,MessageBox,Switcher,TabControl } from 'component-lib';
import { PaymentsModel, RequestAjaxClass} from 'models-lib';

var moment = require('moment');
moment().format();
class CustomerContractDetails extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.PaymentsModel = new PaymentsModel([this]);
        this.PutRequest = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    }

    componentWillMount(){
        this.PutRequest.setApiUrl(Vas.ApiUrl);
        this.PutRequest.setApiKey(Vas.ApiKey);
        this.PutRequest.setAuth(true);
        this.PutRequest.setErrorHandler((data)=>{
          ReactDOM.render(<MessageBox
            AppURL={Vas.ApplicationUrl}
            Title={Vas.Resources.Labels["DefaultPayment"]}
            Message={data.Description} /> , document.getElementById('messageContainer'));
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
          $("#LoadingIconCard").removeClass().addClass('loaderSmall');
        });
        this.PaymentsModel.SetRequest(this.PutRequest);
    }

    Update(observer)
    {
        this.setState({},()=>{
          if(observer === "StandartPaymentsOption"){
            let referenc = this.props.reference;
            let table = this.props.table;
            localStorage.setItem('vas_refresh', "Payment");
            if (this.PaymentsModel.PaymentOption.IsDefaultPaymentMethod === true){
                ReactDOM.render(<MessageBox
                  AppURL={Vas.ApplicationUrl}
                  Title={Vas.Resources.Labels["DefaultPayment"]}
                  Message={Vas.Resources.Labels["DefaultPaymentChanged"]} /> , document.getElementById('messageContainer'));
            } else {
                ReactDOM.render(<MessageBox
                  AppURL={Vas.ApplicationUrl}
                  Title={Vas.Resources.Labels["DefaultPayment"]}
                  Message={Vas.Resources.Labels["DefaultPaymentNotChanged"]} /> , document.getElementById('messageContainer'));
            }
            referenc.load(table.PrepareSendData()); 
            $("#LoadingIconCard").removeClass().addClass('loaderSmall');
            ReactDOM.render(Vas.Resources.Labels["NoPayments"], document.getElementById('paymentDetails'));
          }
        });
    }

    SetDefaultPayment(){
        if (this.refs.defaultPayment){
            $("#LoadingIconCard").removeClass().addClass('loaderSmall');
            let newValue = this.refs.defaultPayment.GetValue();
            
            let curFrom = null;
            if(this.props.data[0].ValidFrom !== null){
              if (this.props.data[0].ValidFrom.length > 0){
                let curValidFrom = DateTimeHelper.StringToDate(this.props.data[0].ValidFrom,false,localStorage.getItem('vas_language'));
                curFrom = moment([curValidFrom.year(),curValidFrom.month(),curValidFrom.date()]).format('YYYY-MM-DD T 00:00:00');
              }
            }
            
            let curTo = null;
            if(this.props.data[0].ValidTo !== null){
              if (this.props.data[0].ValidTo.length > 0){
                let curValidTo = DateTimeHelper.StringToDate(this.props.data[0].ValidTo,false,localStorage.getItem('vas_language'));
                curTo = moment([curValidTo.year(),curValidTo.month(),curValidTo.date()]).format('YYYY-MM-DD T 00:00:00');
              }
            }
            
            
            this.PaymentsModel.PaymentOption = this.props.data[0];
            this.PaymentsModel.PaymentOption.ValidFrom = curFrom;
            this.PaymentsModel.PaymentOption.ValidTo = curTo;
            this.PaymentsModel.PaymentOption.Id = this.props.Id;
            this.PaymentsModel.PaymentOption.IsDefaultPaymentMethod = newValue;

            this.PaymentsModel.CustomerId = this.props.CustomerId;
            this.PaymentsModel.SetStandartPaymentsOption();
        }
    }

    render()
    {   
        let rights = RoleConfiguration.getRoleConfig();
        let role = localStorage.getItem("vas_role");
        
        let right = '';
        if (role === "1"){
            if (rights[1]){
               right =  rights[1]; 
            }
        }
        if (role === "3" || role === "99"){
            if (rights[0]){
                right = rights[0];
            }
        }

        let edit = '';
        if (rights){
            edit = right.Edit;
        }
        
        let defaultPay='';
        if (this.props.data[0].IsDefaultPaymentMethod){
            if (edit === true){
                defaultPay=(<Switcher
                  Id={"Pay"}
                  On={true}
                  ref={"defaultPayment"}
                  referenc={this}
                  OnClick={()=>{this.SetDefaultPayment();}} 
                  />);
            } else {
                defaultPay=(<Icon
                  Name={"Done"}
                  Size={24}
                  Color={"green"}
                  Align={"left"}
                  OnClick={()=>{this.Assign();}}
                  refs={this.props.refs}  />);
            }
        } else {
            if (edit === true){
                defaultPay=(<Switcher
                  Id={"Pay"}
                  On={false}
                  ref={"defaultPayment"}
                  referenc={this}
                  OnClick={()=>{this.SetDefaultPayment();}} 
                  />);
            }
        }

        let from = '';
        let to = '';
        if (this.props.data[0].ValidFrom !== ''){
            from = this.props.data[0].ValidFrom;
        }
        if (this.props.data[0].ValidTo !== ''){
            to = this.props.data[0].ValidTo;
        }
       
        return (<div className={""}>
          <table >
            <tbody>
              <tr>
                <td>
                  <TabControl
                    Id={"Details"} 
                    Content={[
                      { Title:Vas.Resources.Labels["MethodOfPaymentCustomer"],Content:<table>
                        <tbody>
                          <tr>
                            <td colSpan={2}><TextField
                              AppURL={Vas.ApplicationUrl}
                              ref={"nameOfBank"}
                              Width={345}
                              Id="nameOfBank"
                              Editable={false}
                              Label={Vas.Resources.Labels["NameOfBank"]}
                              Value={this.props.data[0].BankName} /></td>
                          </tr>
                          <tr>
                            <td colSpan={2} ><TextField
                              AppURL={Vas.ApplicationUrl}
                              ref={"depositor"}
                              Width={345}
                              Id="depositor"
                              Label={Vas.Resources.Labels["Depositor"]}
                              Value={this.props.data[0].AccountOwner}
                              Editable={false} /></td>
                          </tr>
                          <tr>
                            <td colSpan={2}><TextField
                              AppURL={Vas.ApplicationUrl}
                              Width={345}
                              ref={"iban"}
                              Id="iban"
                              Editable={false}
                              Label={Vas.Resources.Labels["Iban"]}
                              Value={this.props.data[0].Iban} /> </td>
                          </tr>
                          <tr>
                            <td colSpan={2}><TextField
                              AppURL={Vas.ApplicationUrl}
                              Width={345}
                              ref={"bic"}
                              Id="bic"
                              Editable={false}
                              Label={Vas.Resources.Labels["Bic"]}
                              Value={this.props.data[0].BIC} /> </td>
                          </tr>
                          <tr>
                            <td><TextField
                              AppURL={Vas.ApplicationUrl}
                              ref={"validFrom"}
                              Width={170}
                              Id="validFrom"
                              Editable={false}
                              Label={Vas.Resources.Labels["ValidFrom"]}
                              Value={from} /></td>
                            <td><TextField
                              AppURL={Vas.ApplicationUrl}
                              ref={"validTo"}
                              Width={170}
                              Id="validTo"
                              Editable={false}
                              Label={Vas.Resources.Labels["ValidTo"]}
                              Value={to} /></td>
                          </tr>
                          <tr>
                            <td><br />{Vas.Resources.Labels["DefaultMethodOfPayment"]}:</td>
                            <td>{defaultPay} </td>
                          </tr>
                        </tbody>
                      </table> }]} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>);
    }
}
export default CustomerContractDetails;
